/** Format a candidate submission's cost + type as a display string. */
export function formatCost(amount, type) {
  if (amount == null) return "-";
  const suffix = type === "daily_rate" ? "/j" : type === "salary" ? "/an" : "";
  return `${amount.toLocaleString()}€${suffix}`;
}

/** Format the availability field — prefer a concrete date, fall back to the free-text status. */
export function formatAvailability(availabilityDate, availabilityStatus) {
  if (availabilityDate) return new Date(availabilityDate).toLocaleDateString();
  return availabilityStatus || "-";
}

/** Parse a JSON-encoded skill list from a mission column; returns [] on any failure. */
export function parseSkillList(jsonStr) {
  if (!jsonStr) return [];
  try {
    const parsed = JSON.parse(jsonStr);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
